import { createApp } from 'vue';
import './style.css';
import App from './App.vue';
import router from './router';
import { isDebugMode, setupDebug } from './utils/debug';

// 注入全局变量供沙箱中的第三方脚本（gs-thirdparty-script）使用
// 第三方脚本的 webpack 已将 @tencent/viewer-sdk 和 three 设为 externals，
// 运行时从 window.ViewerSDK / window.THREE 获取
import * as ViewerSDK from '@tencent/viewer-sdk';
import * as THREE from 'three';

(window as any).ViewerSDK = ViewerSDK;
(window as any).THREE = THREE;

/**
 * 应用启动前先尝试启用 debug 模式（如 URL 命中 ?debug / ?debug=true）。
 *
 * 放在 createApp 之前执行，覆盖首屏直链场景，让 Vue 应用挂载前的
 * 启动期日志也能被 vConsole 捕获并写入下载 zip 包。
 *
 * setupDebug 内部幂等，重复调用不会重复挂载。
 */
if (isDebugMode()) setupDebug();

// 创建 Vue 应用
const app = createApp(App);
app.use(router);
app.mount('#app');
